const messages = {
  'Verification Link Expiry Duration': 'external.idp.settings.expiryLabel',
  'Specify how long the verification link should remain valid. After this time, users will no longer be able to complete identity verification using the link.':
    'external.idp.settings.expiryTooltip',
  Save: 'external.idpSetUp.save',
  Hours: 'external.idp.settings.hours',
  Saving: 'external.idp.settings.saving',
};

export default messages;
